import { ImageSrcSetEnum } from '../enums';

export type ImageSrcSetSizeMap = Record<ImageSrcSetEnum, string>;

export const SCREEN_BREAKPOINTS = {
  mobile: 320,
  tablet: 700,
  desktop: 1200,
  extraWide: 1440,
} as const;

export const IMAGE_SRC_SET_SIZE_MAP: Partial<ImageSrcSetSizeMap> = {
  big: `${SCREEN_BREAKPOINTS.desktop}w`,
  medium: `${SCREEN_BREAKPOINTS.tablet}w`,
  mobile: `${SCREEN_BREAKPOINTS.mobile}w`,
  card: `${SCREEN_BREAKPOINTS.mobile}w`,
};

export const SIZES = `(max-width: ${SCREEN_BREAKPOINTS.mobile}px) ${SCREEN_BREAKPOINTS.mobile}px, (max-width: ${SCREEN_BREAKPOINTS.desktop - 1}px) ${SCREEN_BREAKPOINTS.tablet}px, (min-width: ${SCREEN_BREAKPOINTS.desktop}px) ${SCREEN_BREAKPOINTS.desktop}px`;

const SUFFIXES = [ImageSrcSetEnum.Mobile, ImageSrcSetEnum.Medium, ImageSrcSetEnum.Big];

export const buildSrcSetBySizeMap = (image: string[], sizeMap = IMAGE_SRC_SET_SIZE_MAP): string => {
  const imageSrcSet: string[] = [...image] as string[];

  let srcSetSegments: string[] = SUFFIXES.reduce((result, conventionedSizeNameSuffix) => {
    const accordingUrl = imageSrcSet.find((url) => url.includes(`-${conventionedSizeNameSuffix}`))?.trim();
    if (accordingUrl && sizeMap[conventionedSizeNameSuffix]) {
      result = [...result, `${accordingUrl} ${sizeMap[conventionedSizeNameSuffix]}`] as any;
    }

    return result;
  }, []);

  if (!srcSetSegments.length) {
    const anyAvailableUrl = imageSrcSet[0];
    srcSetSegments = [`${anyAvailableUrl} ${IMAGE_SRC_SET_SIZE_MAP.big}`];
  }

  return srcSetSegments.join(', ');
};
const IMAGE_PREFIX_SORT: Record<ImageSrcSetEnum, number> = {
  [ImageSrcSetEnum.Mobile]: 1,
  [ImageSrcSetEnum.Medium]: 2,
  [ImageSrcSetEnum.Card]: 3,
  [ImageSrcSetEnum.Big]: 4,
};

const findIndexByName = (name: string): number => {
  let index = 0;
  Object.keys(IMAGE_PREFIX_SORT).some((key) => {
    if (name.includes(key)) {
      index = IMAGE_PREFIX_SORT[key as ImageSrcSetEnum];
      return true;
    }
    return false;
  });
  return index;
};

export const sourceSetToBackgroundImage = (sourceSet: string[]) =>
  `image-set(${sourceSet
    .sort((a, b) => findIndexByName(a) - findIndexByName(b))
    .map((url, idx) => `url(${url}) ${idx + 1}x`)
    .join(', ')})`;
